import dayjs from "dayjs";
import { useSelector } from "react-redux";
const apiUrl = process.env.REACT_APP_API_URL;

const useSaveDocument = () => {
  const { token, fullName } = useSelector((state) => state.auth);
  const { data, csvName, documentId } = useSelector((state) => state.dataTable);

  const setFetchHeaders = (token) => {
    return {
      Authorization: `Bearer ${token}`,
      "Content-type": "application/json",
    };
  };

  const newDocument = async () => {
    const payload = {
      data: new Array(100).fill({}),
      fileName: dayjs().format("YYYY-MM-DD hh:mm:ssA"),
      userFullName: fullName,
    };
    // console.log("payload :>> ", payload);
    try {
      const resp = await fetch(`${apiUrl}/documents`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: setFetchHeaders(token),
      });
      // console.log("resp", resp);
      const json = await resp.json();
      // console.log("POST, json :>>", json);
      return json;
    } catch (error) {
      // console.log(error);
      throw Error(error.message);
    }
  };

  const saveDocument = async () => {
    const payload = { data, csvName, documentId };
    try {
      const resp = await fetch(`${apiUrl}/documents/${documentId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: setFetchHeaders(token),
      });
      // console.log(resp);
      const json = await resp.json();
      // console.log("json :>>", json);
      return json;
    } catch (error) {
      console.log(error);
      throw Error(error.message);
    }
  };

  return { newDocument, saveDocument };
};

export default useSaveDocument;
